import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";
import { PaginationInfo } from "components/CRPComponents/Tables/GenericTable/types";

export const GET_ALL_QUERY = print(gql`
  query GlobalsFinancial($page: Int, $perPage: Int, $search: String) {
    GlobalsFinancial(page: $page, perPage: $perPage, search: $search) {
      items {
        key
        description
      }
      paginationInfo {
        page
        perPage
        hasMore
        totalPages
        totalData
        nextPage {
          page
          perPage
        }
      }
    }
  }
`);

export interface GetAllItem {
  key: string;
  description: string;
}

export interface GetAllGql {
  GlobalsFinancial: {
    items: GetAllItem[];
    paginationInfo: PaginationInfo;
  };
}
